import { ChangeDetectorRef, Component, OnInit, ViewContainerRef } from '@angular/core';
import { ISubscription, ISubscriptionFilter } from './subscriptions.interface';
import { SubscriptionsService } from './subscriptions.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { Sort } from '@angular/material/sort';
import { SubscriptionsModalComponent } from './subscriptions-modal/subscriptions-modal.component';
import * as _ from 'lodash';
import { Broadcaster } from '../../../shared/components/broadcaster.component';
import { DialogService } from '../../../shared/services/dialog/dialog.service';
import { AuthService } from '../../../shared/services/auth.service';
import { IConfirmationDialogOptions } from '../../../shared/services/dialog/confirmation-dialog/confirmation-dialog-options.interface';

let self: any;

@Component({
  selector: 'app-subscriptions',
  templateUrl: './subscriptions.component.html',
  styleUrls: ['./subscriptions.component.css']
})
export class SubscriptionsComponent implements OnInit {
  subscriptions: ISubscription[] = [];
  loading: boolean = false;
  thereAreMore: boolean = false;
  filter: ISubscriptionFilter = {
    sort: '',
    skip: 0,
    limit: 20
  };
  filtered = false;
  scrollSubscription!: Subscription;
  sortOptions: any = {};
  sortOptionsKeys = Object.keys(this.sortOptions);
  selection: any = { all: false };
  isDev!: boolean;

  constructor(
    public _SubscriptionsService: SubscriptionsService,
    private _broadcaster: Broadcaster,
    private _dialogService: DialogService,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
    private _AuthService: AuthService,
    private ref: ChangeDetectorRef
  ) {
    self = this;
    this.registerStringBroadcast();
  }

  ngOnInit() {
    this.isDev = this._AuthService.isRole('dev');
    this.filter.company = this._AuthService.companyId();
    this.getSubscriptions(true);
  }

  getSubscriptions(reset?: boolean) {
    this.loading = true;
    this.thereAreMore = false;
    if (reset) {
      window.scroll(0, 0);
      this.filter.skip = 0;
      this.subscriptions = [];
      this.clearSelection();
    }
    this._SubscriptionsService.getSubscriptions(this.filter).subscribe((products: any) => {
      this.subscriptions = _.concat(this.subscriptions, products);
      const filter: any = this.filter;
      this.thereAreMore = products.length >= filter.limit;
      this.loading = false;
      this.ref.detectChanges();
    })
  }

  loadMore() {
    if (this.thereAreMore && !this.loading) {
      const filter: any = this.filter;
      filter.skip += filter.limit;
      this.getSubscriptions();
    }
  }

  registerStringBroadcast() {
    this.scrollSubscription = this._broadcaster.on<string>('FinishScrollDown')
      .subscribe(() => {
        this.loadMore();
      });
  }

  ngOnDestroy() {
    this.scrollSubscription.unsubscribe();
  }

  sortSubscriptions(sort: any) {
    this.filter.sort = (typeof sort == 'string') ? sort : ((sort.direction == 'asc') ? '' : '-') + sort.active;
    this.getSubscriptions(true);
  }

  openFilter() {
    console.log('openFilter');
  }

  openNewSubscriptionModal() {
    this.openSubscriptionModal({});
  }

  openSubscriptionModal(subscription: ISubscription, readOnly: boolean = false) {
    let config = new MatDialogConfig();
    config.width = '400px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(SubscriptionsModalComponent, config);
    self.dialogRef.componentInstance.subscription = subscription;
    self.dialogRef.componentInstance.readOnly = readOnly;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getSubscriptions(true);
    });
  }

  openDeleteSubscriptionConfirm(subscription: ISubscription, hardDelete: boolean = false) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Eliminar Suscripcion",
      message: "Esta seguro que desea eliminar esta suscripcion?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._SubscriptionsService.deleteSubscription(subscription, hardDelete).subscribe(() => {
            if (hardDelete) this.getSubscriptions(true);
            else subscription.isDeleted = true;
          })
        }
      });
  }

  openRestoreSubscriptionConfirm(subscription: ISubscription) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Restaurar Suscripcion",
      message: "Esta seguro que desea restaurar esta suscripcion?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._SubscriptionsService.restoreSubscription(subscription).subscribe(() => {
            subscription.isDeleted = false;
          })
        }
      });
  }

  clearSelection() {
    this.selection = { all: false }
  }

  toggleSelection(_id?: string) {
    if (_id) {
      this.selection.all = false;
      this.selection[_id] = !this.selection[_id];
    } else {
      this.selection = { all: !this.selection.all }
    }
  }
}